import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_EXPENSES_YEARS = 'ppis/expenses/years';

export default class PPIExpenseYearService extends SfpBaseService {

  static updatePPIExpenseYear(ppi_expense_year) {
    const body = JSON.stringify({ppi_expense_year: {value: ppi_expense_year.value}});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_expense_year.id}/expense/year`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-expense-year-service.js